import React from "react";

const PurchaseInvoiceDetail = () => {
  return <div>PurchaseInvoiceDetail</div>;
};

export default PurchaseInvoiceDetail;
